import { useState, useEffect, useCallback } from 'react';
import { getPaginationRowModel } from '@tanstack/react-table';

const usePagination = ({ paginationLinks, pagination = 'default', getState, getCanNextPage, getCanPreviousPage, nextPage, previousPage, resetPageIndex, options: { autoResetPageIndex = true }, setOptions, setPagination, resetPagination })=>{
    const [currentPageLink, setCurrentPageLink] = useState();
    const { columnFilters, sorting } = getState();
    /**
     * Update table options for links pagination.
     */ useEffect(()=>{
        setOptions((prev)=>{
            if (pagination === 'default') {
                return {
                    ...prev,
                    getPaginationRowModel: getPaginationRowModel()
                };
            }
            return {
                ...prev,
                manualPagination: true,
                pageCount: -1,
                getPaginationRowModel: undefined
            };
        });
    });
    useEffect(()=>{
        // When the filters or the sortBy rules change,
        // we should reset the pagination back to the
        // first page because the results can be totally different.
        if (autoResetPageIndex) {
            resetPagination();
            setCurrentPageLink(undefined);
        }
    }, [
        autoResetPageIndex,
        columnFilters,
        resetPageIndex,
        resetPagination,
        sorting
    ]);
    const getLinksCanNextPage = useCallback(()=>{
        return !!paginationLinks?.next;
    }, [
        paginationLinks?.next
    ]);
    const getLinksCanPreviousPage = useCallback(()=>{
        return !!paginationLinks?.prev;
    }, [
        paginationLinks?.prev
    ]);
    const linksNextPage = useCallback(()=>{
        if (!paginationLinks?.next) {
            return;
        }
        setPagination((state)=>({
                ...state,
                pageIndex: state.pageIndex + 1
            }));
        setCurrentPageLink(paginationLinks.next);
    }, [
        paginationLinks?.next,
        setPagination
    ]);
    const linksPrevPage = useCallback(()=>{
        if (!paginationLinks?.prev) {
            return;
        }
        setPagination((state)=>({
                ...state,
                pageIndex: state.pageIndex - 1
            }));
        setCurrentPageLink(paginationLinks.prev);
    }, [
        paginationLinks?.prev,
        setPagination
    ]);
    if (pagination === 'default') {
        return {
            getCanNextPage,
            getCanPreviousPage,
            nextPage,
            previousPage
        };
    }
    return {
        currentPageLink,
        getCanNextPage: getLinksCanNextPage,
        getCanPreviousPage: getLinksCanPreviousPage,
        nextPage: linksNextPage,
        previousPage: linksPrevPage
    };
};

export { usePagination as default, usePagination };
//# sourceMappingURL=usePagination.es.js.map
